import React from "react";

export default function ColorFrame24({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#fff"
          stroke={fill}
          strokeWidth="10.842"
          d="M263.56 169.696c.372-41.327-32.153-75.124-72.647-75.489-40.494-.364-73.622 32.843-73.994 74.17-.372 41.327 32.153 75.124 72.647 75.489 15.465.139 29.856-4.619 41.758-12.855l23.747 10.125-7.539-25.415c9.895-12.629 15.871-28.605 16.028-46.025z"
        ></path>
        <path
          fill="#fff"
          stroke={fill}
          strokeWidth="10.842"
          d="M115.412 233.654c57.113 0 103.412-45.365 103.412-101.327C218.824 76.366 172.525 31 115.412 31 58.299 31 12 76.366 12 132.327c0 21.372 6.753 41.199 18.282 57.544l-13.695 32.942 35.026-10.734c17.574 13.515 39.726 21.575 63.799 21.575z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
